module.exports = __webpack_public_path__ + "static/media/mshtml_32529.dc0f0e88.ico";